import { render, staticRenderFns } from "./PlateViewer.vue?vue&type=template&id=0f57e817&"
import script from "./PlateViewer.vue?vue&type=script&lang=js&"
export * from "./PlateViewer.vue?vue&type=script&lang=js&"
import style0 from "./PlateViewer.vue?vue&type=style&index=0&id=0f57e817&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports